import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareBehindSquare3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconSquareBehindSquare3"><Path fillRule="evenodd" clipRule="evenodd" d="M16 8V3.75C16 2.7835 15.2165 2 14.25 2H3.75C2.7835 2 2 2.7835 2 3.75V14.25C2 15.2165 2.7835 16 3.75 16H8V20.25C8 21.2165 8.7835 22 9.75 22H20.25C21.2165 22 22 21.2165 22 20.25V9.75C22 8.7835 21.2165 8 20.25 8H16ZM14.25 16C15.2165 16 16 15.2165 16 14.25V9H20.25C20.6642 9 21 9.33579 21 9.75V20.25C21 20.6642 20.6642 21 20.25 21H9.75C9.33579 21 9 20.6642 9 20.25V16H14.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareBehindSquare3;
